<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <div class="footer-logo">
    <div class="footer-logo__wrapper">
      <NuxtImg class="footer-logo__logo" src="/images/logo-since.webp" alt="logo" />
    </div>
    <div class="footer-logo__text">
      {{ t('resursiDistributionDescription') }}
    </div>
  </div>
</template>

<style lang="less">
.footer-logo {
  .flex-column(@size-x9);

  &__logo {
    width: 225px;
    height: 74px;
  }

  &__text {
    font-size: @size-x4;
    line-height: 100%;
    font-weight: 400;
    color: @color-dove-gray;
    max-width: 340px;

    @media @tablet {
      font-size: 14px;
    }
  }

  @media @1024 {
    .flex-column(@size-x2);

    align-items: center;

    &__wrapper {
      display: flex;
      justify-content: center;
    }

    &__logo {
      width: 153px;
      height: 50px;
    }

    &__text {
      font-size: 14px;
      line-height: 129%;
      font-weight: 400;
      color: @color-dove-gray;
      text-align: center;
    }
  }
}
</style>
